import React, { Component } from 'react';

import Banner from '../../Components/Banner/Banner';
import TextCard from '../../Components/TextCard/TextCard';
import Modal from '../../Components/Modal/Modal';

import { withContext } from '../../App';

import './styles.scss';

class PageBodyRenderer extends Component {
  componentDidMount() {
    const { markVideoWatched } = this.props.context;

    // If landing directly on a subpage, don't play the intro video on navigating to the home page
    markVideoWatched(true);
  }

  render() {
    const { topic, context: { topics, topicData, modalOpen } } = this.props;

    return (
      <React.Fragment>
        <Banner topic={topics[topic]} />
        <div className="content-wrapper">
          <div className="page-body-animation main-content">
            <div className="row">
              {
                topicData[topic].intro &&
                topicData[topic].intro.map((item, index) => {
                  return (
                    <div key={index} className="text-card-wrapper col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
                      <TextCard topic={topic} showAnswerButtons={index === topicData[topic].intro.length - 1} className="mt-2 mb-2">
                        <p dangerouslySetInnerHTML={{ __html: item }} />
                      </TextCard>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
        {
          modalOpen &&
          <Modal topic={topic} />
        }
      </React.Fragment>
    );
  }
}

export default withContext(PageBodyRenderer);
